import { ArticleCard, Box } from '@doist/marketist';
import { SectionHeader } from 'components/SectionHeader/SectionHeader';
import { useTranslation } from 'next-i18next';
import css from './article-grid.module.css';
import type { PartialCategory, PartialSection } from '@doist/help-center-utils';
type ArticlesGridProps = {
  id?: string;
  category: PartialCategory;
  currentSection: PartialSection;
};
export default function ArticlesGrid({
  category,
  currentSection,
  ...rest
}: ArticlesGridProps) {
  const {
    t
  } = useTranslation('helpcenter');
  return <Box className={css.content} {...rest} data-sentry-element="Box" data-sentry-component="ArticlesGrid" data-sentry-source-file="article-grid.tsx">
            <SectionHeader className={css.heading} style={{
      '--section-mb': '44px'
    }} textAlignment={{
      narrow: 'left',
      wide: 'left'
    }} title={category.name} subtitle={currentSection.id === 0 ? t('allIntegrations') : currentSection.name} data-sentry-element="SectionHeader" data-sentry-source-file="article-grid.tsx" />
            <Box tag="ul" className={css.grid} data-sentry-element="Box" data-sentry-source-file="article-grid.tsx">
                {currentSection.articles.map(article => <ArticleCard buttonTarget="_self" key={article.id} tag="li" buttonIcons={false} label={t('readArticle')} title={article.title} href={article.href} />)}
            </Box>
        </Box>;
}